/**
 * The default logo size (used for sidebar workspace avatar and logo)
 */
export const LOGO_SIZE = 25;
